import type { Lang } from './i18n';

/** Locales that read digits in their own script where the reader expects it. */
const LOCALE: Record<Lang, string> = { en: 'en-AE', ar: 'ar-AE', ur: 'ur-PK', hi: 'hi-IN' };

/**
 * Money always carries its currency and always uses Western digits.
 *
 * Arabic-Indic numerals are correct in prose but a resident comparing this to a
 * bank SMS or a paper receipt needs the two to look the same. Getting a rent
 * figure wrong by a rendering choice is not worth the authenticity.
 */
// whole amounts stay whole; a payment with fils shows both digits rather than rounding
export const money = (n: number, currency = 'AED'): string => {
  const v = Number(n || 0);
  const fils = Number.isInteger(v) ? 0 : 2;
  return `${currency} ${v.toLocaleString('en-AE', { minimumFractionDigits: fils, maximumFractionDigits: 2 })}`;
};

export const fmtDate = (d: string | null, lang: Lang): string =>
  d ? new Date(`${String(d).slice(0, 10)}T00:00:00`).toLocaleDateString(LOCALE[lang], {
    day: 'numeric', month: 'long', year: 'numeric',
  }) : '—';

export const today = (): string => new Date().toISOString().slice(0, 10);

export const daysBetween = (from: string, to: string): number =>
  Math.round((new Date(`${to}T00:00:00Z`).getTime() - new Date(`${from}T00:00:00Z`).getTime()) / 864e5);
